module.exports = __webpack_public_path__ + "static/vue/vue_mall/fonts/iconfont.946e64c4.eot";